var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40028 20.1665C7.67653 20.1665 7.95279 20.051 8.1537 19.8458L11.0418 16.8948H15.9956C16.0961 16.8948 17.0629 16.8948 17.8289 16.2405C18.7079 15.4964 18.8209 14.316 18.8335 14.1749V6.28441C18.8084 6.05347 18.6451 5.00141 17.9043 4.33425C17.1634 3.67992 16.2216 3.67992 16.0333 3.66709H5.30952C5.24674 3.66709 4.2045 3.61577 3.28783 4.47538C2.48418 5.23235 2.35861 6.0663 2.34605 6.15611L2.3335 14.0851C2.34605 14.2647 2.44651 15.4451 3.37573 16.202C4.17939 16.8564 4.74446 16.9205 4.94537 16.9205H6.33292V19.076C6.33292 19.5122 6.59662 19.9099 6.98589 20.0895C7.12402 20.1408 7.26215 20.1665 7.40028 20.1665Z",
    fill: "#CCE1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4724 5.43436V2.2915L21.5835 7.7915L15.4724 12.7915V9.7915C11.8057 9.7915 8.85201 12.2439 7.8335 13.2915C8.2409 8.26293 13.0958 5.95817 15.4724 5.43436Z",
    fill: "#0B70FD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.2205db31.svg";
export { ForwardRef as ReactComponent };